export default "__VITE_ASSET__vGcGA1xk__"